/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
let autocomplete;
let addressField;
let city;
let region;

const SearchAddress = {
	/**
	 * @description Initialize
	 */
	init: function() {
		this.initAutocomplete();
		this.submitRedirect();
	},

	initAutocomplete: function() {
		addressField = document.querySelector('#ship-address');
		if (!addressField) {
			return false;
		}
		// Create the autocomplete object, restricting the search predictions to
		// addresses in the US and Canada.
		// eslint-disable-next-line no-undef
		autocomplete = new google.maps.places.Autocomplete(addressField, {
			componentRestrictions: {country: ['us']},
			fields: ['address_components', 'geometry'],
			types: ['address'],
		});
		// When the user selects an address from the drop-down, populate the
		// address fields in the form.
		autocomplete.addListener('place_changed', this.addressComponents);
	},

	addressComponents: function() {
		// Get the place details from the autocomplete object.
		const place = autocomplete.getPlace();
		let address1 = '';
		let postcode = '';
		const event = document.createEvent('Event');
		event.initEvent('change', false, true);
		// args: string type, boolean bubbles, boolean cancelable
		// Get each component of the address from the place details,
		// and then fill-in the corresponding field on the form.
		// place.address_components are google.maps.GeocoderAddressComponent objects
		// which are documented at http://goo.gle/3l5i5Mr
		for (const component of place.address_components) {
			const componentType = component.types[0];
			// eslint-disable-next-line default-case
			switch (componentType) {
				case 'street_number': {
					address1 = `${component.long_name} ${address1}`;
					break;
				}

				case 'route': {
					address1 += component.short_name;
					break;
				}

				case 'postal_code': {
					postcode = `${component.long_name}${postcode}`;
					break;
				}

				case 'postal_code_suffix': {
					postcode = `${postcode}-${component.long_name}`;
					break;
				}
				case 'locality':
					city = component.long_name;
					break;
				case 'administrative_area_level_1': {
					region = component.short_name;
					break;
				}
				case 'country':
					// document.querySelector('#country').value = component.long_name;
					break;
			}
		}

		const addressObj = {
			address: address1,
			city: city,
			region: region,
			zip: postcode
		};

		Global.setCookie('addressObj', addressObj);
	},

	submitRedirect: function() {
		$('.js-banner-submit').on('click', () => {
			const address = $('.js-address').val();
			if (address) {
				$('.js-address-validation').empty();
				window.location.replace(window.location.href + '/apply/');
			} else {
				$('.js-address-validation').text('Please complete this required field');
			}
		});
	},

	prefillAddressFields: function() {
		const form = document.querySelector('.js-hubspot-form');
		if (!form) {
			return false;
		}
		// const event = document.createEvent('Event');
		const addressObj = Global.readCookie('addressObj');
		if (addressObj) {
			const event = document.createEvent('Event');
			event.initEvent('change', false, true);
			const address1Field = document.querySelector('.js-hubspot-form input[name="address"]');
			address1Field.value = addressObj.address;
			const address1FieldReal = form.querySelector('input[name="address"]');
			address1FieldReal.value = addressObj.address;
			address1FieldReal.dispatchEvent(event);
			const postalField = document.querySelector('.js-hubspot-form input[name="zip"]');
			postalField.value = addressObj.zip;
			const realPostcode = form.querySelector('input[name="zip"]');
			realPostcode.value = addressObj.zip;
			realPostcode.dispatchEvent(event);

			const cityField = document.querySelector('.js-hubspot-form input[name="city"]');
			cityField.value = addressObj.city;
			const realCity = form.querySelector('input[name="city"]');
			realCity.value = addressObj.city;
			realCity.dispatchEvent(event);

			const regionField = document.querySelector('.js-hubspot-form input[name="state"]');
			regionField.value = addressObj.region;
			const realRegion = form.querySelector('input[name="state"]');
			realRegion.value = addressObj.region;
			realRegion.dispatchEvent(event);
		}

	},
};

export default SearchAddress;
